import { createApiService } from "@/core/api/apiService";
import type { BusinessDto } from "../types/businessTypes";

export function createBusinessApiService() {
  const api = createApiService("businesses");
  return {
    getAll: (signal?: AbortSignal): Promise<BusinessDto[]> =>
      api.get<BusinessDto[]>("", { signal }),
  };
}

export const businessApiService = createBusinessApiService();
